var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('login-form',{attrs:{"redirect":"/","locale-selectable":true,"show-logo":true,"logo-style":"height:300px;"}})}
var staticRenderFns = []

export { render, staticRenderFns }